document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll('.animated-text');

	elements.forEach((el) => {
		const innerElementExists = el.querySelector('text-animation');

		if (innerElementExists || !el.textContent.trim()) return;

		const textAnimation = document.createElement('text-animation');
		
		textAnimation.setAttribute('data-hover', el.textContent);
		textAnimation.textContent = el.textContent;

		el.replaceChildren(textAnimation);
	});
});

// Product Info Tabs Web Component
class ProductInfoTabs extends HTMLElement {
	constructor() {
		super();
		
		this.currentTab = null;
	}

	connectedCallback() {
		this.setupTabs();
	}

	setupTabs() {
		const buttons = this.querySelectorAll('.product-info-tab__button');
		const contents = this.querySelectorAll('.product-info-tabs__content');

		// Set initial active tab
		const activeButton = this.querySelector('.product-info-tab__button--active');
		
		if (activeButton) {
			this.currentTab = activeButton.getAttribute('data-tab');
		}

		// Add click listeners to buttons
		buttons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				
				const tabName = button.getAttribute('data-tab');
				
				this.switchTab(tabName);
			});
		});
	}

	switchTab(tabName) {
		const buttons = this.querySelectorAll('.product-info-tab__button');
		const contents = this.querySelectorAll('.product-info-tabs__content');

		// Update button states
		buttons.forEach((button) => {
			if (button.getAttribute('data-tab') === tabName) {
				button.classList.add('product-info-tab__button--active');
			} else {
				button.classList.remove('product-info-tab__button--active');
			}
		});

		// Update content visibility
		contents.forEach((content) => {
			if (content.getAttribute('data-tab') === tabName) {
				content.classList.add('product-info-tabs__content--active');
			} else {
				content.classList.remove('product-info-tabs__content--active');
			}
		});

		this.currentTab = tabName;
	}
}

// Register the custom element
if (!window.customElements.get('product-info-tabs')) {
	window.customElements.define('product-info-tabs', ProductInfoTabs);
}
